/**
 * PC 端和移动端共用
 */

import React from 'react';

export function FirstChild(props) {
  const childrenArray = React.Children.toArray(props.children);
  return childrenArray[0] || null;
}



// WEBPACK FOOTER //
// ./lib/components/FirstChild.jsx